import { PageTracking } from "library/hoc/PageTracking";
import { Button, Container, Input, Stack, Text } from "basis";
import { useEffect, useRef } from "react";
import { CreditCard } from "../CreditCard/CreditCard";
import { SvgInline } from "../SvgInline/SvgInline";
import { validateConfirmPin, validateNewPin } from "./validation";

export const FormContentComponent = ({
  accountInfo,
  formValues,
  validateField,
  sendOtpMutation,
}) => {
  const { newPin, confirmPin } = formValues;
  const confirmPinRef = useRef();

  useEffect(() => {
    confirmPinRef.current = confirmPin;
  });

  useEffect(() => {
    if (confirmPinRef.current !== "") {
      validateField("confirmPin");
    }
  }, [newPin, validateField]);

  return (
    <Stack gap="8">
      <Container bg="grey.t05" padding="4">
        <CreditCard
          cardName={accountInfo.cardName}
          cardEndsWith={accountInfo.cardEndsWith}
        />
      </Container>
      <SvgInline name="icon-set-pin-confetti" size="92" />
      <Text as="h3" textStyle="heading5" textStyle-sm="heading4">
        Let’s create a 4 digit PIN for your card
      </Text>
      <Text>
        Don’t choose a PIN that can be easily guessed. If you do, you may be
        liable for unauthorised transactions.
      </Text>
      <Container width="100%" width-xs="320">
        <Input
          name="newPin"
          label="New PIN"
          type="password"
          variant="numeric"
          maxLength="4"
          helpText="Your PIN must not be a set of single repeating or consecutive numbers (e.g. 1111, 1234, 4321)."
          validate={validateNewPin}
        />
      </Container>
      <Container width="100%" width-xs="320">
        <Input
          name="confirmPin"
          label="Confirm PIN"
          type="password"
          variant="numeric"
          maxLength="4"
          validate={validateConfirmPin}
          validateData={{ newPin: formValues.newPin }}
        />
      </Container>
      <Button type="submit" width="160" loading={sendOtpMutation.isLoading}>
        Next
      </Button>
    </Stack>
  );
};

const pageData = {
  page: {
    pageType: "input-page",
    siteSection: "accounts",
    siteSubSection: "manage",
    pageTitle: "change-pin",
  },
};

export const FormContent = ({ Component = FormContentComponent, ...props }) => (
  <PageTracking pageData={{ ...pageData, productId: [props.productId] }}>
    <Component {...props} />
  </PageTracking>
);
